<div class="app-main__inner">

  <!-- ── Success state ──────────────────────────────────────────────────────── -->
  <div *ngIf="successResult" class="card ict-success-card text-center p-4">
    <div class="ict-success-icon mx-auto mb-3">
      <i class="pe-7s-check"></i>
    </div>
    <h5 class="fw-bold text-success mb-1">Transfer Executed Successfully</h5>
    <p class="text-muted mb-3">
      {{ successResult.primaryCenterName }} &harr; {{ successResult.secondaryCenterName }}
    </p>
    <div class="d-flex justify-content-center gap-4 mb-4">
      <div class="ict-stat-pill ict-stat-pill--issue">
        <span class="ict-stat-num">{{ successResult.issuedCount }}</span>
        <span class="ict-stat-lbl">Issued Out</span>
      </div>
      <div class="ict-stat-pill ict-stat-pill--receive">
        <span class="ict-stat-num">{{ successResult.receivedCount }}</span>
        <span class="ict-stat-lbl">Received In</span>
      </div>
    </div>
    <button class="btn btn-primary" (click)="startNew()">
      <i class="pe-7s-refresh-2 me-1"></i> New Transfer
    </button>
  </div>

  <!-- ── Main UI ────────────────────────────────────────────────────────────── -->
  <ng-container *ngIf="!successResult">

    <!-- Compact config toolbar -->
    <div class="ict-toolbar">
      <span class="ict-tb-label">From</span>
      <input *ngIf="isManager" type="text" class="form-control form-control-sm ict-tb-center-input ict-tb-primary"
             readonly [value]="primaryCenter?.centerName || 'Loading...'" />
      <select *ngIf="isAdmin" class="form-select form-select-sm ict-tb-select ict-tb-primary"
              (change)="setPrimaryCenter($any($event.target).value)">
        <option value="">— Select Primary —</option>
        <option *ngFor="let c of allCenters" [value]="c._id">{{ c.centerName }}</option>
      </select>
      <span class="ict-tb-sep">⇄</span>
      <span class="ict-tb-label">To</span>
      <select class="form-select form-select-sm ict-tb-select ict-tb-secondary"
              [(ngModel)]="secondaryCenterId"
              [disabled]="!primaryCenter || availableSecondaryCenters.length === 0">
        <option value="">— Select Secondary —</option>
        <option *ngFor="let c of availableSecondaryCenters" [value]="c._id">{{ c.centerName }}</option>
      </select>
      <span class="ict-tb-divider"></span>
      <span class="ict-tb-label">Date</span>
      <input type="date" class="form-control form-control-sm ict-tb-date" [(ngModel)]="transferDate" />
    </div>

    <!-- Transfer panels -->
    <div class="ict-panels">

      <!-- ── Issue panel (outgoing) ──────────────────────────────────────── -->
      <div class="card ict-panel">
        <div class="card-header ict-panel-header ict-panel-header--issue">
          <span><i class="pe-7s-upload me-2"></i>Issue from {{ primaryCenter?.centerName || 'Primary' }}</span>
          <span class="badge bg-primary rounded-pill">{{ issueBooks.length }}</span>
        </div>
        <div class="card-body">
          <p class="ict-panel-desc">Books leaving the primary center → going to secondary</p>

          <div class="ict-scan-row">
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-light"><i class="pe-7s-barcode"></i></span>
              <input #issueSrInput type="text" class="form-control" [(ngModel)]="issueSrNo"
                     placeholder="Scan or type Sr No, press Enter"
                     (keydown.enter)="addIssueBook()"
                     [disabled]="!primaryCenter" />
              <button class="btn btn-primary ict-add-btn" type="button"
                      (click)="addIssueBook()"
                      [disabled]="!issueSrNo.trim() || !primaryCenter">
                <span *ngIf="!issueProcessing"><i class="pe-7s-plus"></i></span>
                <span *ngIf="issueProcessing" class="spinner-border spinner-border-sm"></span>
              </button>
            </div>
          </div>

          <div class="text-danger small mt-1" *ngIf="issueError">
            <i class="pe-7s-attention me-1"></i>{{ issueError }}
          </div>

          <div class="ict-book-list mt-2" *ngIf="issueBooks.length > 0">
            <div class="ict-book-item" *ngFor="let book of issueBooks">
              <span class="ict-sr">{{ book.bookSrNo }}</span>
              <span class="ict-name">{{ book.bookName }}</span>
              <button class="ict-remove" type="button" (click)="removeIssueBook(book.bookSrNo)" title="Remove">&#x2715;</button>
            </div>
          </div>

          <div class="ict-empty" *ngIf="issueBooks.length === 0">
            <i class="pe-7s-upload"></i>
            <span>No books added for issue</span>
          </div>
        </div>
      </div>

      <!-- ── Receive panel (incoming) ────────────────────────────────────── -->
      <div class="card ict-panel">
        <div class="card-header ict-panel-header ict-panel-header--receive">
          <span><i class="pe-7s-download me-2"></i>Receive in {{ primaryCenter?.centerName || 'Primary' }}</span>
          <span class="badge bg-success rounded-pill">{{ receiveBooks.length }}</span>
        </div>
        <div class="card-body">
          <p class="ict-panel-desc">Books arriving at the primary center ← from secondary</p>

          <div class="ict-scan-row">
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-light"><i class="pe-7s-barcode"></i></span>
              <input #receiveSrInput type="text" class="form-control" [(ngModel)]="receiveSrNo"
                     placeholder="Scan or type Sr No, press Enter"
                     (keydown.enter)="addReceiveBook()" />
              <button class="btn btn-success ict-add-btn" type="button"
                      (click)="addReceiveBook()"
                      [disabled]="!receiveSrNo.trim()">
                <span *ngIf="!receiveProcessing"><i class="pe-7s-plus"></i></span>
                <span *ngIf="receiveProcessing" class="spinner-border spinner-border-sm"></span>
              </button>
            </div>
          </div>

          <div class="text-danger small mt-1" *ngIf="receiveError">
            <i class="pe-7s-attention me-1"></i>{{ receiveError }}
          </div>

          <div class="ict-book-list mt-2" *ngIf="receiveBooks.length > 0">
            <div class="ict-book-item ict-book-item--receive" *ngFor="let book of receiveBooks">
              <span class="ict-sr ict-sr--receive">{{ book.bookSrNo }}</span>
              <span class="ict-name">{{ book.bookName }}</span>
              <button class="ict-remove" type="button" (click)="removeReceiveBook(book.bookSrNo)" title="Remove">&#x2715;</button>
            </div>
          </div>

          <div class="ict-empty" *ngIf="receiveBooks.length === 0">
            <i class="pe-7s-download"></i>
            <span>No books added for receive</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Execute footer -->
    <div class="ict-footer">
      <div class="text-danger small" *ngIf="executeError">
        <i class="pe-7s-attention me-1"></i>{{ executeError }}
      </div>
      <div class="ict-footer-info" *ngIf="!executeError && primaryCenter && secondaryCenterId">
        <span *ngIf="issueBooks.length > 0">{{ issueBooks.length }} book(s) to issue</span>
        <span *ngIf="issueBooks.length > 0 && receiveBooks.length > 0"> · </span>
        <span *ngIf="receiveBooks.length > 0">{{ receiveBooks.length }} book(s) to receive</span>
      </div>
      <button class="btn btn-primary ict-execute-btn" (click)="execute()" [disabled]="!canExecute || isExecuting">
        <span *ngIf="!isExecuting"><i class="pe-7s-check me-1"></i>Execute Transfer</span>
        <span *ngIf="isExecuting" class="d-flex align-items-center gap-2">
          <span class="spinner-border spinner-border-sm"></span> Processing...
        </span>
      </button>
    </div>

  </ng-container>

</div>
